import { jsx, css } from '@emotion/react';

import { connectLocation } from '../../location/LocationConnectors';
import Image from '../oc-image';

const styles = css`
  border-top: none;
  border-bottom: none;
`;

const BuildingEnclosureSolutionsBanner = connectLocation(({ t }) => (
  <div
    css={styles}
    className="oc-full-bleed-content-and-image"
    style={{
      backgroundImage:
        "url('https://imagecdn.owenscorning.com/ocimages/image/upload/v1604330616/insulation/building-enclosure-solutions-banner-bg.jpg')",
    }}
  >
    <div className="content-container content-right">
      <div className="content left-align">
        <Image
          src="https://imagecdn.owenscorning.com/ocimages/image/upload/v1604324637/insulation/building-enclosure-solutions-banner.jpg"
          className="mobile-img"
          alt="graphic depiction of an enclosure solution"
        />

        <h2>{t('rainbarrier.enclosure_solutions_heading')}</h2>

        <p>{t('rainbarrier.enclosure_solutions_copy')}</p>

        <div className="cta-container">
          <a
            href="https://www.owenscorning.com/en-us/insulation/commercial/enclosure"
            className="oc-cta-button"
            data-track="learn-more"
            data-track-destination="Enclosure Solutions"
            data-track-element-location="main section CTA"
          >
            {t('rainbarrier.enclosure_solutions_cta_text')}
          </a>
        </div>
      </div>
    </div>
  </div>
));

BuildingEnclosureSolutionsBanner.WrappedComponent.displayName = 'BuildingEnclosureSolutionsBanner';

export default BuildingEnclosureSolutionsBanner;
